import React from 'react';
import PropTypes from 'prop-types';

import DemonstrationToGradeSection from './DemonstrationToGradeSection';
import LessonsToGradeSection from './LessonsToGradeSection';

const ToGradeSection = props => {
  if (props.progress.demonstration) {
    return <DemonstrationToGradeSection {...props} />;
  }

  return <LessonsToGradeSection {...props} />;
};

ToGradeSection.propTypes = {
  progress: PropTypes.shape({
    id: PropTypes.number,
    userName: PropTypes.string,
    lessonName: PropTypes.string,
    daysAwaitingGrade: PropTypes.number,
    demonstration: PropTypes.shape({
      id: PropTypes.number,
      prompt: PropTypes.string,
      givenAnswer: PropTypes.string,
      noteToGraders: PropTypes.string,
    }),
  }),
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.number,
  }),
  markProgressGraded: PropTypes.func,
  ziggeoApiKey: PropTypes.string,
};

export default ToGradeSection;
